import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiClientService } from 'api-services';
import { BehaviorSubject, catchError, map, Observable, finalize } from 'rxjs';
import { AuthService, SharedService } from 'services';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NewLicenseService {
  constructor(
    private apiClient: ApiClientService,
    private authService: AuthService,
    private http: HttpClient,
    private sharedService: SharedService
  ) { }

  public newLicenseRequest: BehaviorSubject<any> = new BehaviorSubject(true);

  // shared data comopnent to component
  public newLicenseRequestObj(data: any) { //the component that wants to update something, calls this fn
    this.newLicenseRequest.next(data); //next() will feed the value in Subject
  }

  getBGQNonBGQ(type, tenantId) {
    return this.apiClient.get(`api/NewLicenseRequest/newlicense-questionnaire/${type}/${tenantId}`, null, null, true)
  }

  getNASDCRDStates(tenantId) {
    return this.apiClient.get(`api/NewLicenseRequest/GetNASD_CRDStates/${tenantId}`, null, null, true)
  }

  createBatch(batch: any) {
    return this.apiClient.post(`api/LicenseRenewalRequest/createBatch`, batch, null, true)
  }

  submitNewLicenseRequest(newLicenseObj: any) {
    return this.apiClient.post(`api/NewLicenseRequest/createBulkNewLicenseRequest`, newLicenseObj, null, false)
  }

  generateRequestPDF(newLicenseRequestDetails: any) {
    return this.apiClient.post(`api/NewLicenseRequest/generateRequestPDF`, newLicenseRequestDetails, null, true)
  }

  //Upload license Renewal files
  public UploadRequestFile(formData: FormData): Observable<any> {
    const headers = new HttpHeaders().append(
      "Content-Disposition",
      "multipart/form-data"
    );
    this.sharedService.showLoader();
    return this.http
      .post(environment.baseUrl + `api/LicenseRenewalRequest/insertTransactionSnapshotFile`, formData, {
        headers: headers,
        reportProgress: false,
      })
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return this.apiClient.handleError(err);
        }),
        finalize(() => {
          this.apiClient.hideLoader();
        })
      );

    // return this.http.post(environment.baseUrl + `api/LicenseRenewalRequest/insertTransactionSnapshotFile`, formData, {
    //   headers: headers,
    //   reportProgress: false,
    // });
  }

  public DownloadRequestFile(transactionSnapshotFileId) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream',
      })
    };

    return this.http.get(environment.baseUrl + `api/LicenseRenewalRequest/getTransactionSnapshotFile/${transactionSnapshotFileId}`, httpOptions)
      .pipe(map((response: any) => {
        let data = response;
        return data;
      }
      ));
  }
   
  public getNewLicenseSupportedStates(): Observable<any> {
    return this.apiClient.get('api/NewLicenseRequest/NewLicenseSupportedStates');
  }

  public getAllNIPRCountry(): Observable<any> {
    return this.apiClient.get('api/NewLicenseRequest/getAllNIPRCountry');
  }

  public getNewLicenseApplicantDetails(userId: number, tenantId: number) {
    return this.apiClient.get(`api/NewLicenseRequest/NewLicenseApplicantDetails/${userId}/${tenantId}`, null, null, false);
  }
 
  public checkAppointerInfoExists(reqParam) {
    return this.apiClient.get(`api/NewLicenseRequest/checkAppointerInfoExists/${reqParam.tenantId}/${reqParam.userId}/${reqParam.transType}`, null, null, false);
  }

  public insertUpdateUserEmploymentHistory(employmentHistoryObj: any) {
    return this.apiClient.post(`api/NewLicenseRequest/InsertUpdateUserEmploymentHistory`, employmentHistoryObj, null, false)
  }

  public getUserEmploymentHistory(userId: number, tenantId: number) {
    return this.apiClient.get(`api/NewLicenseRequest/getUserEmploymentHistory/${tenantId}/${userId}`, null, null, false);
  }

  public getNewLicenseAffiliationStates(type: string) {
    return this.apiClient.get(`api/NewLicenseRequest/GetNewLicenseAffiliationStates/${type}`, null, null, true)
  }

  public getRenewLicenseAffiliationStates(type: string) {
    return this.apiClient.get(`api/NewLicenseRequest/getRenewLicenseAffiliationStates/${type}`, null, null, true);
  }

  public deleteUserEmploymentHistory(employmentHistoryId: number) {
    return this.apiClient.delete(`api/NewLicenseRequest/deleteUserEmploymentHistory/${employmentHistoryId}`, null, null, true);
   }
  
   public getUserNonResidentStates(userId: number, tenantId: number) {
    return this.apiClient.get(`api/NewLicenseRequest/GetUserNonResidentStates/${tenantId}/${userId}`, null, null, false);
  }

  public getAllStates(): Observable<any> {
    return this.apiClient.get('api/LinesOfAuthority/getAllStates');
  }

  public getStatesByCountryId(niprCountryId: number): Observable<any> {
    return this.apiClient.get(`api/LinesOfAuthority/getStatesByCountryId/${niprCountryId}`);
  }

  public getFirmTypeListByStateCode(stateCode: string) {
    return this.apiClient.get(`api/NewLicenseRequest/getFirmTypeByStateCode/${stateCode}`, null, null, true);
  }

  public getFirmOwnerAndRespProducerList(stateIds: string, branchId:number) {
    return this.apiClient.get(`api/NewLicenseRequest/getFirmOwnerAndRespProducerForNewLicense/${stateIds}/${branchId}`, null, null, true);
  }

  public validateFirmTypeForSelectedStates(selectedStateCodes: string, firmTypeCode: number) {
    return this.apiClient.get(`api/NewLicenseRequest/validateFirmTypeForSelectedStates/${selectedStateCodes}/${firmTypeCode}`, null, null, true);
  }

  public insertUpdateAffiliationForBusinessEntity(businessEntityObj: any) {
    return this.apiClient.post(`api/NewLicenseRequest/insertUpdateAffiliationForBusinessEntity`, businessEntityObj,
    null,false);
  }

  public getAffiliationForBusinessEntity() {
    return this.apiClient.get(`api/NewLicenseRequest/getAffiliationForBusinessEntity`,null,
      null,false);
  }

  public deleteAffiliationForBusinessEntity(affiliationForBusinessEntityId: number) {
    return this.apiClient.delete( `api/NewLicenseRequest/deleteAffiliationForBusinessEntity/${affiliationForBusinessEntityId}`,
      null, null,true);
  }

  public insertUpdateAffiliationForProducer(producerObj: any) {
    return this.apiClient.post(`api/NewLicenseRequest/insertUpdateAffiliationForProducer`,
      producerObj, null, false);
  }

  public getAffiliationForProducer(userId: number) {
    return this.apiClient.get(`api/NewLicenseRequest/getAffiliationForProducer/${userId}`,
      null, null, false);
  }

  public deleteAffiliationForProducer(affiliationForProducerId: number) {
    return this.apiClient.delete(`api/NewLicenseRequest/deleteAffiliationForProducer/${affiliationForProducerId}`,
      null, null, true);
  }

  createNewLicenseRequestProducer(listNewLicenseRequest: any) {
    return this.apiClient.post('api/NewLicenseRequest/createNewLicenseRequestProducer', listNewLicenseRequest, null, true);
  }

  public getAffiliationForBusinessEntityNewLicense(branchId: number) {
    return this.apiClient.get(`api/NewLicenseRequest/getAffiliationForBusinessEntityNewLicense/${branchId}`, null,
      null, false);
  }

  public getUserBiographicData(branchId?: number, userId?: number) {
    return this.apiClient.get(`api/NewLicenseRequest/getUserBiographicData/${branchId}/${userId}`, null, null, false);
  }

  public saveUserBiographicData(userBiographicData: any) {
    return this.apiClient.post(`api/NewLicenseRequest/saveUserBiographicData`,
      userBiographicData, null, false);
  }
}
